import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';

@Component({
  selector: 'app-paacs',
  templateUrl: './paacs.component.html',
  styleUrls: ['./paacs.component.scss']
})
export class PaacsComponent implements OnInit {


  loading: boolean = false;
  form: FormGroup
  blockList: any;
  filterblockList: any;
  villageList: any;
  filtervillageList: any;
  panchayatcList: any;
  filterpanchayatcList: any;
  disId: any
  role: number;
  public RoleEnumType = RoleType
  isCheckedTrue: boolean = false;
  districtList: any;
  filterListdistrict: any;
  PaccsType: any;

  constructor(private formBuilder: FormBuilder,
    private cashBookingService: CashBookingService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PaacsComponent>,
    private usersessionService: UserSessionService,
    private alertService: AlertService) {

    this.disId = this.data.districtId;
    this.PaccsType = this.data.paccsType
    this.role = this.usersessionService.roleId()


  }
  onBlurEvent(ScSt) {
    // You can perform actions based on the input field name

    const membersValue = Number(this.form.get('members').value);
    const scstValue = Number(this.form.get('ScSt').value);

    // if (membersValue < scstValue ) {
    if (scstValue > membersValue && this.PaccsType == 1) {
      // this.form.get('ScSt').setErrors({ scstInvalid: true });
      this.alertService.warning("SC/ST members count should not exceed Total members in PACCS");
      this.form.controls['ScSt'].setValue("");
    } else {
      // this.form.get('ScSt').setErrors(null);
      // this.form.controls['ScSt'].setValue(null);
    }

  }




  ngOnInit(): void {
    this.initialValidators()
    this.getDistrict();
    if (this.role == this.RoleEnumType.PAACS) {
      this.form.controls['districtId'].setValidators(Validators.required)
      this.form.controls['districtId'].updateValueAndValidity()

      this.form.controls['block'].setValidators(Validators.required)
      this.form.controls['block'].updateValueAndValidity()

      this.form.controls['panchayat'].setValidators(Validators.required)
      this.form.controls['panchayat'].updateValueAndValidity()

      this.form.controls['members'].setValidators(Validators.required)
      this.form.controls['members'].updateValueAndValidity()

      this.form.controls['machinary'].setValidators(Validators.required)
      this.form.controls['machinary'].updateValueAndValidity()
      if (this.PaccsType == 1) {
        this.form.controls['ScSt'].setValidators(Validators.required)
        this.form.controls['ScSt'].updateValueAndValidity()
      }


      this.form.controls['village'].setValidators(Validators.required)
      this.form.controls['village'].updateValueAndValidity()




    }

  }

  initialValidators() {
    this.form = this.formBuilder.group({
      'districtId': ['',],
      'block': ['',],
      'panchayat': ['',],
      'person': ['', Validators.required],
      'mobile': ['', Validators.required],
      'email': ['', Validators.required],
      'members': ['',],
      'machinary': ['',],
      'ScSt': ['',],
      'village': ['',]
    })
  }


  getDistrict() {
    this.cashBookingService.districtData(1, true).subscribe(result => {
      if (result) {
        this.districtList = result;
        this.filterListdistrict = this.districtList.slice();
        if (this.districtList.length === 1) {
          this.form.controls['districtId'].setValue(this.districtList[0].key);
          this.getBlock();
        }
        if (this.disId !== 0) {
          this.form.controls['districtId'].setValue(this.disId);
          this.getBlock();
        }
      }
    });
  }

  getBlock() {
    this.cashBookingService.getLookUpblockbyId(this.disId, 1, true).subscribe(res => {
      this.blockList = res
      this.filterblockList = this.blockList.slice();
      if (this.filterblockList.length === 1) {
        this.form.controls['block'].setValue(this.filterblockList[0].key)
        this.blockChange();
      }
    })
  }
  blockChange() {
    this.form.controls['village'].setValue(null);
    this.form.controls['panchayat'].setValue(null);
    this.panchayatcList = [];
    this.filterpanchayatcList = [];
    this.villageList = [];
    this.filtervillageList = []
    this.cashBookingService.getvillageList(this.form.value.block, 1, true).subscribe(res => {
      this.villageList = res;
      this.filtervillageList = this.villageList.slice()
      if (this.filtervillageList.length === 1) {
        this.form.controls['village'].setValue(this.filtervillageList[0].key)
        this.villageChange();
      }
    })
  }

  villageChange() {
    this.panchayatcList = [];
    this.filterpanchayatcList = [];
    this.form.controls['panchayat'].setValue(null);
    this.cashBookingService.gramPanchayatLookUp(this.form.value.village, true).subscribe(res => {
      this.panchayatcList = res;
      this.filterpanchayatcList = this.panchayatcList.slice();
      if (this.filterpanchayatcList.length === 1) {
        this.form.controls['panchayat'].setValue(this.filterpanchayatcList[0].key)
      }
    })
  }


  onCancel() {
    this.dialogRef.close();

  }

  onSubmit() {
    if (this.form.valid) {
      var data = {
        'id': this.usersessionService.userId(),
        'firstName': this.form.value.person,
        'email': this.form.value.email,
        'mobileNo': this.form.value.mobile,
        'totalMemberInPAACS': this.form.value.members == '' ? 0 : Number(this.form.value.members),
        'totalScStMember': this.form.value.ScSt == '' ? 0 : Number(this.form.value.ScSt),
        'isMachineryAvailable': this.isCheckedTrue,
        'blockId': this.form.value.block == '' ? null : this.form.value.block,
        'villageId': this.form.value.village == '' ? null : this.form.value.village,
        'gramPanchayatId': this.form.value.panchayat == '' ? null : this.form.value.panchayat
      }
      this.cashBookingService.updatePAACS(data).subscribe(res => {
        if (res.isSuccess) {
          this.dialogRef.close(res);
          this.alertService.success("User details updated successfully")
        }
        else {
          this.alertService.error(res.htmlFormattedFailures)
        }
      })
    }
    else {
      this.validateFormControl()
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }


}
